import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const showSalesPagePercentageOff = createSelector(testTargetOffersSelector, offers => offers.salesPagePercentageOf || Empty.Object);

export { showSalesPagePercentageOff };
